import { LocalStorageAuthStorage } from '@creditornot/wolt-auth';

export const authStorage = new LocalStorageAuthStorage({ key: 'auth-data' });
